import { Component, OnInit } from '@angular/core';
import { NavigationStart, NavigationEnd, Router } from '@angular/router';
import { LoaderService } from './core/service/loader/loader.service';
import { ModalService } from './core/service/modal/modal.service';
import { AuthService, LoginResponse } from './core/service/authentication/auth.service';
import { TicketService } from './core/service/tickets/tickets.service';
import { PlayPeriod } from './core/models/play-period.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  activeModal = '';
  playPeriod!: PlayPeriod;
  allowUserPurchase = false;
  isSeedRoute = false;

  constructor(
    private modalService: ModalService,
    private router: Router,
    private loaderService: LoaderService,
    private authService: AuthService,
    private ticketService: TicketService
  ) {
    this.modalService.modalState$.subscribe((modalName) => {
      this.activeModal = modalName;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isSeedRoute = event.urlAfterRedirects === '/seed';
      }
    });
  }

  ngOnInit(): void {
    this.initializeUserFromToken();
    this.setupRouterLoader();
  }

  private initializeUserFromToken(): void {
    this.loaderService.showLoader();

    const token = this.authService.getAuthenticationToken();
    const currentUserId = this.authService.getCurrentUserId();

    if (token && currentUserId) {
      this.authService
        .getUserById(currentUserId ?? '')
        .subscribe((response) => {
          this.authService.currentUser$.next(response.content);

          this.loaderService.hideLoader();
        });
    } else {
      this.authService
        .login(
          environment.TRY_MODE_EMAIL_ADDRESS,
          environment.TRY_MODE_PASSWORD
        )
        .subscribe((response) => {
          const authResponse = response.content as LoginResponse;

          this.authService.setCurrentUserId(authResponse.user.id ?? '');
          this.authService.setAuthenticationToken(
            authResponse.authorization.token
          );

          this.loaderService.hideLoader();

          location.reload();
        });
    }

    this.ticketService.getPlayPeriod().subscribe((response) => {
      this.ticketService.playPeriod$.next(response.content);
    });
  }

  private setupRouterLoader(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loaderService.showLoader();
      } else if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.loaderService.hideLoader();
        }, 500);
      }
    });
  }
}
